import React, { useRef, useState,useEffect } from "react";
import emailjs from "@emailjs/browser";
import { useTranslation } from "react-i18next";
import Map from "./Map";
import { FaPhone } from "react-icons/fa6";
import { IoIosMail } from "react-icons/io";

const MailComponent = () => {
   const { t, i18n } = useTranslation();
   
     const changeLanguage = (lng) => {
       i18n.changeLanguage(lng);
       localStorage.setItem("lng", lng);
     };
   
     useEffect(() => {
       changeLanguage(localStorage.getItem("lng") || "en");
     }, []);
  const form = useRef();
  const [isSent, setIsSent] = useState(false);

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_d35tuax", // Ваш EmailJS Service ID
        "template_3oewx24", // Ваш EmailJS Template ID
        form.current,
        "p6xcZiplCoSX_bERQ" // Ваш Public Key
      )
      .then(
        () => {
          setIsSent(true); // Уведомление об успехе
          form.current.reset(); // Очистить форму после отправки
        },
        (error) => {
          console.error("Failed to send message:", error.text);
        }
      );
  };

  return (
    <section id="contact" className="bg-white ">
      <div id="contact" className="max-w-7xl mx-auto mt-10 p-6">
        <div className="grid grid-cols-1 md:grid-cols-2 my-14 p-10 gap-8 items-end rounded-xl   bg-gradient-to-r from-primary/100 to-primaryDark/70 backdrop-blur-lg shadow-lg">
          {/* Левая колонка с текстом */}
          <div>
            <h2 className="text-3xl font-bold text-white mb-4 ">
              {t("form_header")}
            </h2>
            <p className="text-white mb-8 text-lg ">{t("form-text")}</p>
            <div className="flex items-center mb-4 ">
              {" "}
              <p className="text-lg  font-bold pr-4">
                <FaPhone className="text-white size-5 " />
              </p>
              <a
                href="tel:+994557443306"
                className="text-white hover:text-gray-200 text-lg"
              >
                +994-55-744-33-06
              </a>
            </div>
            <div className="flex items-center mb-7 " >
            <p className="text-lg font-bold pr-4">
              <IoIosMail className="text-white size-7 " />
            </p>
            <a
              href="mailto:info@afs.az"
              className="text-white hover:text-gray-200 text-lg"
            >
              info@finmanagement.az
            </a>
            </div>
           
            <Map />
          </div>

          {/* Правая колонка с формой */}
          <div className="p-6 bg-white shadow-lg rounded-lg ">
            <h2 className="text-2xl font-bold text-gray-600 text-center mb-6">
              {t("mailform_header")}
            </h2>
            <form
              ref={form}
              onSubmit={sendEmail}
              className="flex flex-col space-y-4"
            >
              {/* Поле имени */}
              <label className="text-lg font-medium text-gray-700 dark:text-gray-300">
                {t("mailform_name")}:
                <input
                  type="text"
                  name="name"
                  placeholder={t("mailform_name")}
                  className="border rounded p-2 w-full mt-2 focus:ring-2 focus:ring-sky-400"
                  required
                />
              </label>

              {/* Поле Email */}
              <label className="text-lg font-medium text-gray-700 dark:text-gray-300">
                {t("mailform_email")}:
                <input
                  type="email"
                  name="email"
                  placeholder={t("mailform_email")}
                  className="border rounded p-2 w-full mt-2 focus:ring-2 focus:ring-sky-400"
                  required
                />
              </label>

              {/* Поле сообщения */}
              <label className="text-lg font-medium text-gray-700 dark:text-gray-300">
                {t("mailform_message")}:
                <textarea
                  name="message"
                  placeholder={t("mailform_message")}
                  className="border rounded p-2 w-full mt-2 h-32 focus:ring-2 focus:ring-sky-400 resize-none min-w-full max-w-full min-h-32 max-h-32"
                  required
                />
              </label>

              {/* Кнопка отправки */}
              <button
                type="submit"
                className=" object-contain transition-transform transform hover:scale-105 duration-300 from-primary/50 to-primaryDark/70 backdrop-blur-lg bg-gradient-to-r text-white py-2 px-4 rounded "
              >
                {t("mailform_button")}
              </button>
            </form>

            {/* Уведомление об успехе */}
            {isSent && (
              <p className="mt-4 text-center text-green-600 font-semibold">
                Your message has been sent successfully!
              </p>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default MailComponent;
